/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * WIE DER RICHTIGE DATENSATZ GEFUNDEN WIRD (Vorgabe des Betreibers,
 * 16.09.2026: „2. Abschnitt Wie wird der richtige Datensatz ermittelt?").
 * 
 * Gilt nur, wenn `datenbankId` gesetzt ist. Ein Feld der eigenen
 * Datenbank gibt es einmal — dort gibt es nichts zu waehlen.
 * 
 *   ALLE      — eine Zeile je zugeordnetem Datensatz (die Spieler).
 *   VERGLEICH — der eine Datensatz, dessen Feld dem Feld des
 *               geoeffneten Datensatzes gleicht (Bahnen.Nummer =
 *               Runde.Aktuelle Bahn). So findet der „Tipp fuer diese
 *               Bahn" seinen Datensatz.
 *   BESTIMMT  — ein fest gewaehlter Datensatz.
 *   ERSTER    — der erste zugeordnete.
 * @export
 */
export const DatabaseFieldDatensatzWeg = {
    Alle: 'ALLE',
    Vergleich: 'VERGLEICH',
    Bestimmt: 'BESTIMMT',
    Erster: 'ERSTER'
} as const;
export type DatabaseFieldDatensatzWeg = typeof DatabaseFieldDatensatzWeg[keyof typeof DatabaseFieldDatensatzWeg];


export function DatabaseFieldDatensatzWegFromJSON(json: any): DatabaseFieldDatensatzWeg {
    return DatabaseFieldDatensatzWegFromJSONTyped(json, false);
}

export function DatabaseFieldDatensatzWegFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseFieldDatensatzWeg {
    return json as DatabaseFieldDatensatzWeg;
}

export function DatabaseFieldDatensatzWegToJSON(value?: DatabaseFieldDatensatzWeg | null): any {
    return value as any;
}

